export var EPIC_END = '@@redux-observable/EPIC_END';


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/venyou-stripe/~/redux-observable/lib/es/EPIC_END.js
// module id = ../../../../redux-observable/lib/es/EPIC_END.js
// module chunks = 3